module.exports = __webpack_public_path__ + "public/img/img-mobile-prakerja-1.2d189423.png";